import { useMutation } from "@tanstack/react-query";
import React from "react";

import Button from "../../../../components/Button";
import Modal from "../../../../components/Modal";
import Spacer from "../../../../components/Spacer";
import Spinner from "../../../../components/Spinner";
import Text from "../../../../components/Text";
import { StaticToast } from "../../../../components/Toast";

import useToast from "../../../../hooks/useToast";

import { resyncTeamsApp } from "../../../../api/services";

import PropTypes from "../../../../lib/prop-types";

import css from "./TeamsModals.module.scss";

const DisplayTroubleShootModal = (props) => {
	const { data, handleClose, handleRefresh } = props;

	const { tenantID, teamID, teamDisplayName } = data;

	const toast = useToast();

	const { mutate: handleResync, isLoading: isResyncing } = useMutation({
		mutationKey: ["resyncTeam", tenantID, teamID],
		mutationFn: () => resyncTeamsApp({ filters: { tenantID, teamID } }),
		onSuccess: () => {
			handleRefresh();
		},
		onError: () => {
			toast("Error resyncing", {
				type: "error",
				size: "small",
			});
			handleRefresh();
		},
	});

	const content = (
		<div className={css.modalContainer}>
			<div className={css.modalTeamNameContainer}>
				<Text size="sub-heading" weight="bold">
					{teamDisplayName}
				</Text>
			</div>
			<div className={css.instructionText}>
				<Text size="paragraph-1" weight="semi-bold">
					This action will reset PerformYard in {teamDisplayName} while preserving existing settings.
				</Text>
			</div>

			<Spacer height={4} />

			<div className={css.centeredModalWarning}>
				<StaticToast
					contentStyle={{ fontSize: "50%" }}
					message='Uninstall the app in Microsoft Teams by visiting the "Manage
		team" page'
					size="small"
					type="info"
				/>
			</div>
			<div className={`${css.buttonWrapper} ${css.centeredButtons}`}>
				<Button size="large" color="blue" className={css.marginRight} onClick={() => handleClose()}>
					Cancel
				</Button>
				{isResyncing ? (
					<div className={css.spinner}>
						<Spinner />
					</div>
				) : (
					<Button size="large" color="green" onClick={() => handleResync(tenantID, teamID)}>
						Yes, Reset
					</Button>
				)}
			</div>
		</div>
	);

	return <Modal content={content} handleClose={handleClose} size="large" />;
};
DisplayTroubleShootModal.propTypes = {
	data: PropTypes.object.isRequired,
	handleClose: PropTypes.func.isRequired,
	handleRefresh: PropTypes.func.isRequired,
};

export default DisplayTroubleShootModal;
